import * as R from "ramda";

const root = R.lensProp("billing-report");

const data = R.compose(root, R.lensProp("data"));

const error = R.compose(root, R.lensProp("error"));

const pagination = R.compose(root, R.lensProp("pagination"));

const csvUrl = R.compose(root, R.lensProp("csvUrl"));

const loading = R.compose(root, R.lensProp("isLoading"));

const totals = R.compose(root, R.lensProp("totals"));

export default Object.assign(root, {
  data,
  error,
  loading,
  pagination,
  csvUrl,
  totals,
});
